import { scopedChannelApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ChannelApiResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { RenderedValuesResponse } from '@/types/channelRenderedValues';
import type { ReadRequestOptions } from '../requestOptions';

export async function getRenderedValuesForProduct(
  scope: RequestScope,
  args: {
    productId: number;
    subscriptionIds: number[];
    includeInactive?: boolean;
    includeAiSuggestionDetails?: boolean;
  },
  options: ReadRequestOptions
): Promise<ChannelApiResponse<RenderedValuesResponse>> {
  try {
    if (!args.productId || args.productId < 1) {
      throw new Error('Valid productId is required');
    }
    if (!Array.isArray(args.subscriptionIds) || args.subscriptionIds.length === 0) {
      throw new Error('At least one subscriptionId is required');
    }

    const params = new URLSearchParams();
    params.append('subscription_ids', args.subscriptionIds.join(','));

    if (args.includeInactive) {
      params.append('include_inactive_channels', 'true');
    }

    if (args.includeAiSuggestionDetails) {
      params.append('include_ai_suggestion_details', 'true');
    }

    const res = await scopedChannelApi(scope).get<RenderedValuesResponse>(
      `atts/rendered_values/product/${args.productId}?${params.toString()}`,
      options
    );
    return { data: res.data, status: res.status };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
}
